module.exports = __webpack_public_path__ + "img/gsy.ec3bf776.jpg";